import { useEffect, useState } from "react";
import "./Header.css";
import headLogo from "../images/fusco_logo.png";

function Header() {
  const [open, setOpen] = useState(false);

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Close if resized out of mobile
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 600) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <>
      <div className="header-spacer" />

      <header className="header">
        <div className="logo">
          <img src={headLogo} alt="Fusco's Detailing Logo" className="logo-img" />
          <span className="logo-text">Fusco’s Detailing</span>
        </div>

        {/* Desktop/Tablet nav */}
        <nav className="nav nav--desktop" aria-label="Primary">
          <a href="#home" className="nav-link">Home</a>
          <a href="#services" className="nav-link">Services</a>
          <a href="#contact" className="nav-button">Contact</a>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="menu-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-controls="mobile-menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span className="menu-icon" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>

        {/* Mobile dropdown */}
        <nav
          id="mobile-menu"
          className={`mobile-menu ${open ? "is-open" : ""}`}
          aria-label="Mobile"
        >
          <a href="#home" className="mobile-link" onClick={() => setOpen(false)}>Home</a>
          <a href="#services" className="mobile-link" onClick={() => setOpen(false)}>Services</a>
          <a href="#contact" className="mobile-link mobile-button" onClick={() => setOpen(false)}>Contact</a>
        </nav>
      </header>
    </>
  );
}

export default Header;